export default function Chip({ text, filled = false }) {
  return (
    <span
      className={`inline-block py-1 px-3 text-xs font-mono font-medium border rounded-full transition ease-out duration-300
      ${
        filled
          ? "bg-black text-white border-black hover:border-emerald-500"
          : "bg-transparent text-slate-800 border-black hover:bg-black hover:text-white hover:border-emerald-500"
      }`}
    >
      {text}
    </span>
  );
}
